.a-ficon
  display: inline-flex
  align-items: center
  justify-content: center
  width: 18px
  font-size: 16px
  line-height: 1
  color: $syncra.muted
